import React, { useEffect, useState } from "react";
import './Contact.css';

function ContactUS() {
  const [team, setTeam] = useState([]);

  // Fetch the team data from db.json
  useEffect(() => {
    fetch("/Data/db.json")
      .then(res => res.json())
      .then(data => {
        if (data.team) setTeam(data.team);
      })
      .catch(err => console.error("Error loading team data:", err));
  }, []);

  return (
    <div className="contact-wrapper">
      {/* About Us */}
      <div className="contact-header">
        <h3>About Us</h3>
        <p>
          WIP Aluminium Works, based in Venda, is dedicated to transforming homes with premium aluminium solutions. Founded by Ndou Victor, a visionary young entrepreneur, our company was born from a desire to bridge the gap in high-quality, affordable aluminium doors, windows, and custom installations for the local community. We combine innovative design, durable materials, and skilled craftsmanship to create functional, elegant, and long-lasting solutions that enhance the beauty and security of every home. At WIP Aluminium Works, we’re passionate about helping families build houses they’re proud to call home.
        </p>
      </div>

      {/* Contact Cards */}
      <div className="contact-cards">
        <div className="ccard">
          <div className="cicon">
            <span className="material-symbols-outlined">call</span>
          </div>
          <h5>Whatsapp</h5>
          <p>072 696 5644</p>
          <p>Emergency Service</p>
          <button onClick={() => window.open("https://wa.me/27726965644?text=Hi%20there!", "_blank")}>Message Now</button>
        </div>

        <div className="ccard">
          <div className="cicon">
            <span className="material-symbols-outlined">mail</span>
          </div>
          <h5>Email</h5>
          <p>ipfieisrael@gmail.com</p>
          <p>Fast Responses</p>
          <button onClick={() => window.location.href = "mailto:ipfieisrael@gmail.com?subject=Service&body=Hi"}>Email Us</button>
        </div>

        <div className="ccard">
          <div className="cicon">
            <span className="material-symbols-outlined">location_on</span>
          </div>
          <h5>Location</h5>
          <p>Tshaulu Village</p>
          <p>Next to Police Station</p>
          <button onClick={() => window.open("https://www.google.com/maps/dir/?api=1&destination=-22.7975792,30.7651010","_blank")}>Location</button>
        </div>

        <div className="ccard">
          <div className="cicon">
            <span className="material-symbols-outlined">schedule</span>
          </div>
          <h5>Working Hours</h5>
          <p>Mon-Fri: 7AM-5PM</p>
          <p>Sat: 8AM-1PM</p>
          <button>Schedule</button>
        </div>
      </div>

      {/* Team Section */}
      <div className="team-section">
        <h2>Meet Our Team</h2>
        <p>Our dedicated professionals ensure your project is handled with care and expertise.</p>
        <div className="team-cards">
          {team.map(member => (
            <div key={member.id} className="team-card">
              <img src={member.imageUrl} alt={member.name} />
              <h5>{member.name}</h5>
              <p>{member.role}</p>
              <p>{member.bio}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default ContactUS;